var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items
    ? _c(
        "div",
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "b-form-checkbox",
            {
              key: index,
              staticClass: "checkbox",
              attrs: {
                name: "checkbox-1",
                value: "true",
                size: "lg",
                "unchecked-value": "false",
              },
              model: {
                value: item.selected,
                callback: function ($$v) {
                  _vm.$set(item, "selected", $$v)
                },
                expression: "item.selected",
              },
            },
            [
              _vm._v("\n        " + _vm._s(index + 1 + ". ") + "\n        "),
              _c("span", { staticClass: "item" }, [
                _vm._v("\n            " + _vm._s(item.content) + "\n        "),
              ]),
            ]
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }